<template>
    <div>
        <RouterView v-if="header" name="header"></RouterView>
        <RouterView name="default"></RouterView>
        <transition name="fade">
            <RouterView class="provider_page_container" name="provider_page"></RouterView>
        </transition>
        <RouterView name="footer"></RouterView>
    </div>
</template>

<script>
    import i18n from '@/mixins/i18n'

    export default {
        name: 'App',
        data() {
            return {
                header: false
            }
        },
        mixins: [i18n],
        props: {
            locale: {
                type: String,
                default: null
            }
        },
        beforeMount() {
            this.setLocale(this.locale)
            this.hasHeader()
        },
        beforeRouteUpdate(to, from, next) {
            this.setLocale(to.params.locale)
            next()
        },
        methods: {
            hasContentOverlays() {
                return this.$store.state.contentOverlays.counter > 0
            },
            activePage() {
                if (this.$route.params.url_case) {
                    return `active_page`
                }

                return `inactive_page`
            },
            hasHeader() {
                if((this.$route.query.header || null) === null){
                    this.header = true;
                }else{
                    this.header = (this.$route.query.header == 'true');
                }
            }
        },
    }
</script>

<style lang="scss">
    #app {
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        min-height: 320px;
    }

    .fade-enter {
        background-color: #000;
    }

    .fade-enter-active {
        transition: opacity .25s ease;
        background-color: #000;
    }

    .fade-leave {
        transition: opacity .2s ease;
        opacity: 0;
    }

    .fade-leave-active {
        transition: opacity .3s ease;
        opacity: 0;
    }


</style>
